module.exports = __webpack_public_path__ + "static/agency-2bd9408625ca31ffe9e74be82bd86c1c.jpg";